export default function LocaleChange(newLocale: string) {
   const segments = window.location.pathname.split('/');
   segments[1] = newLocale;
   const newPath = segments.join('/');
   window.location.href = newPath;
}
